// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBLxpTorGuO4PlmBKzRUNnoL5IRidVm7I8",
  authDomain: "laser-engraver-business.firebaseapp.com",
  projectId: "laser-engraver-business",
  storageBucket: "laser-engraver-business.firebasestorage.app",
  messagingSenderId: "431603830400",
  appId: "1:431603830400:web:b6c14c093adc8659dba065",
  measurementId: "G-4RLH81QHHS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export the Firebase instances
export { app, analytics };